import * as React from 'react';

import * as styles from './styles.css';

export const Wrapper: React.FC = props => {
  return <div className={styles['container']}>{props.children}</div>;
};

Wrapper.displayName = 'Wrapper';
